import { Flex } from '@chakra-ui/react';
import { Asset, SlideItemType, VideoSlideType } from '@llx/common';

import VideoItem from './items/VideoItem';

type Props = {
  slide: VideoSlideType;
  assets: Asset[];
};

function VideoSlide({ slide, assets }: Props) {
  return (
    <Flex height="100%" alignItems="center" justifyContent="center">
      {slide.items.map((item, idx) => {
        switch (item.type) {
          case SlideItemType.VIDEO:
            return <VideoItem key={`videoSlideItem-${idx}`} item={item} assets={assets} />;
        }
      })}
    </Flex>
  );
}

export default VideoSlide;
